module.exports = __webpack_public_path__ + "static-portal/img/icon-05.ea28555.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeManage/module/icons/icon-05.png
// module id = ynKa
// module chunks = 4